import { Link } from "react-router-dom";
import { site, stats } from "@/mocks/site";
import { posts } from "@/mocks/posts";

function formatNum(value: number) {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}w`;
  return `${(value / 1000).toFixed(1)}k`;
}

export default function Hero() {
  const topPosts = [...posts].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=playful%20flat%20vector%20illustration%20of%20a%20vibrant%20carnival%20of%20speech%20bubbles%2C%20watermelon%20slices%2C%20popcorn%20and%20sticker%20faces%20bursting%20outward%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20shapes%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=wg-hero-01&orientation=landscape"
        alt="网爆吃瓜 - 吃瓜娱乐二创内容聚集地插画"
        title="网爆吃瓜 表情包 段子 神回复 梗图"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/85 via-foreground-950/70 to-primary-950/70"></div>

      <div className="relative container-page py-16 md:py-24 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7 w-full">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs whitespace-nowrap">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-emotion-laugh-line"></i>
              </span>
              吃瓜娱乐二创聚集地 · 每日三更
            </span>
            <h1 className="mt-5 text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight text-balance">
              边吃瓜边玩梗
              <span className="block mt-2 text-primary-300">快乐加倍</span>
            </h1>
            <p className="mt-5 max-w-xl text-sm md:text-base text-background-200 leading-relaxed">
              {site.brand}聚集了全网的{site.slogan}素材：表情包、段子、神回复、梗图与二创视频持续上新，群众评论同步围观，看到好笑的顺手就能存下来。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line"></i>
                </span>
                开始吃瓜
              </a>
              <Link
                to="/about#submit"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
                投稿你的二创
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5 max-w-xl">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="text-xs text-background-300">{item.label}</dt>
                  <dd className="mt-1 text-xl md:text-2xl font-heading text-accent-400">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="lg:col-span-5 w-full">
            <div className="rounded-lg bg-background-50/95 backdrop-blur border border-background-50/40 p-4 md:p-5">
              <div className="flex items-center justify-between">
                <h2 className="text-base text-foreground-950 flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                    <i className="ri-line-chart-line"></i>
                  </span>
                  今日吃瓜热榜
                </h2>
                <span className="text-xs text-foreground-400">每小时更新</span>
              </div>
              <ol className="mt-4 space-y-3">
                {topPosts.map((post, index) => (
                  <li key={post.id}>
                    <Link to={`/post/${post.id}`} className="group flex items-start gap-3 cursor-pointer">
                      <span
                        className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-medium ${
                          index === 0
                            ? "bg-accent-500 text-accent-950"
                            : index < 3
                              ? "bg-primary-100 text-primary-700"
                              : "bg-background-100 text-foreground-500"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                          {post.title}
                        </span>
                        <span className="mt-1 block text-xs text-foreground-400">
                          {post.author} · {formatNum(post.views)} 次围观
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}